import { Transaction, TransactionType } from 'types/rest/assetCatalogTypes';
import { MockServiceTemplate } from 'store/mockServiceTemplates/mockServiceTemplateTypes';
import { MockService, MockServiceTransaction } from 'types/rest/mockServiceTypes';
import acApi from 'axios/ac/acApi';
import _ from 'lodash';
import { mockServicePatchAction } from 'store/mockServices/mockServiceList/mockServiceListActions';
import store from 'store/configureStore';
import { updateMockServiceTemplate } from 'store/mockServiceTemplates/mockServiceTemplatesActions';
import { isTemplate } from '../../../../../utils/miscUtil';

export const updateTransactionPriority = async (
  entity: MockServiceTemplate | MockService,
  transactions: Transaction[],
) => {
  const txnIds = _.map(transactions, txn => {
    return { txnId: txn.id, priority: txn.priority } as MockServiceTransaction;
  });
  const msPatch: MockServiceTemplate | MockService = { ...entity, mockServiceTransactions: txnIds };
  if (!isTemplate(entity)) {
    await store.dispatch(mockServicePatchAction(msPatch));
  } else {
    await store.dispatch(updateMockServiceTemplate(msPatch));
  }
  return msPatch;
};

/**
 * Gets transactions for priority modal (based on the context)
 * @param entity - current entity in the context
 * @param type - optional transaction type
 */
export const getTransactionsForPriorityModal = async (
  entity: MockServiceTemplate | MockService,
  type: TransactionType,
): Promise<Transaction[]> => {
  let transactions = [];
  try {
    const params = {
      serviceId: entity.serviceId,
      limit: -1,
      sortBy: 'priority',
      // type: type,
    };

    // Get list of transactions for current entity in the context:
    // Virtual Service
    if (!isTemplate(entity)) {
      if (entity.isDraft) {
        transactions = (await acApi.mockServiceDrafts.getTransactions(entity.id, params)).data.result;
      } else {
        transactions = (await acApi.mockServices.getTransactions(entity.id, params)).data.result;
      }
    }
    // Template
    else {
      if (entity.isDraft) {
        transactions = (await acApi.templateDrafts.getTransactions(entity.id, params)).data.result;
      } else {
        transactions = (await acApi.templates.getTransactions(entity.id, params)).data.result;
      }
    }
    return _.orderBy(transactions, 'priority');
  } catch (e) {}
  return [];
};
